/** Whether Amplify has a Hosted UI (Google / Apple) sign-in in progress in this browser. */
export const hasInflightOAuth = (): boolean => {
    try {
        return Object.keys(localStorage).some((key) => key.startsWith("CognitoIdentityServiceProvider") && key.endsWith(".inflightOAuth") && localStorage.getItem(key) === "true");
    } catch {
        return false;
    }
};
